import SubjectAddress from '@Domain/Subjects/SubjectAddress';
import * as React from 'react';
import { useParams } from 'react-router-dom';

const parseIdentifier = (value: string | undefined): number | null => {
	const identifier = Number(value);

	return value !== undefined && Number.isInteger(identifier) && identifier >= 1 ? identifier : null;
};

/** Reads the dossier address from the route: `:beneficiary`, else `:subjectType` + `:subject`. */
const useSubjectAddressParams = (): { subject: SubjectAddress | null } => {
	const { beneficiary, subjectType, subject } = useParams<{
		beneficiary: string;
		subjectType: string;
		subject: string;
	}>();

	return React.useMemo(() => {
		if (beneficiary !== undefined) {
			const beneficiaryId = parseIdentifier(beneficiary);

			return { subject: beneficiaryId !== null ? SubjectAddress.forBeneficiary(beneficiaryId) : null };
		}

		const subjectId = parseIdentifier(subject);

		if (subjectType === undefined || subjectId === null) {
			return { subject: null };
		}

		return { subject: new SubjectAddress(subjectType, subjectId) };
	}, [beneficiary, subjectType, subject]);
};

export default useSubjectAddressParams;
